import { FilterConfig } from '@hakimo-ui/hakimo/types';

export enum CameraIntegrationType {
  RTSP = 'RTSP',
  AVIGILON = 'AVIGILON',
  GENETEC = 'GENETEC',
  EXACQVISION = 'EXACQVISION',
  MILESTONE = 'MILESTONE',
}

export enum CameraDetailViews {
  OVERVIEW = 'overview',
  SPECIAL_ZONES = 'specialZones',
  PLAYBACK = 'playback',
  PRESENCE = 'presence',
  SETTINGS = 'settings',
}

export const DEFAULT_PLAYBACK_PERIOD = 15; //days
export const DEFAULT_CAM_FILTER = {
  location: { values: [], negative: false },
};

export const filterConfigs: FilterConfig[] = [
  {
    type: 'location',
    label: 'Camera Location',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
];
